module.exports = __webpack_public_path__ + "img/search-hero-overflow-infiniti.56106b9e.png";